/**
 * @file polyfills
 * @author yuanhuihui  2017/9/4
 */

// es6 polyfills
// import 'core-js/es6';
// Added parts of es6 which are necessary for your project or your browser support requirements.
import 'core-js/es6/symbol';
import 'core-js/es6/object';
import 'core-js/es6/function';
import 'core-js/es6/parse-int';
import 'core-js/es6/parse-float';
import 'core-js/es6/number';
import 'core-js/es6/math';
import 'core-js/es6/string';
import 'core-js/es6/date';
import 'core-js/es6/array';
import 'core-js/es6/regexp';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/weak-map';
import 'core-js/es6/weak-set';
import 'core-js/es6/typed';
import 'core-js/es6/reflect';
// add the 'includes' method of array
import 'core-js/es7/array';
// remove es6 promise when use zone.js
// import 'core-js/es6/promise';

// import 'core-js/es7/reflect';



// WEBPACK FOOTER //
// ./src/polyfills.js